export default "__VITE_ASSET__b0a07085__"